import 'dayjs/locale/zh';
import 'dayjs/locale/en';
import isToday from 'dayjs/plugin/isToday';
import isYesterday from 'dayjs/plugin/isYesterday';
import calendar from 'dayjs/plugin/calendar';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import updateLocale from 'dayjs/plugin/updateLocale';
import isBetween from 'dayjs/plugin/isBetween';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { dayjsPlugin } from '@zk/framework-vue';
import dayjs from 'dayjs';
import { getTimezoneOffset } from 'date-fns-tz';

const { calendar: zkCalendar, militaryTime } = dayjsPlugin;
dayjs.extend(isYesterday);
dayjs.extend(isToday);
dayjs.extend(calendar);
dayjs.extend(localizedFormat);
dayjs.extend(updateLocale);
dayjs.extend(isBetween);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(quarterOfYear);
dayjs.extend(weekOfYear);
dayjs.extend(zkCalendar);
dayjs.extend(militaryTime);

dayjs.updateLocale('zh', {
  formats: {
    LT: 'h:mm A',
    LTS: 'h:mm:ss A',
    L: 'YYYY/MM/DD',
    LL: 'YYYY年M月D日',
    LLL: 'YYYY年M月D日Ah点mm分 A',
    LLLL: 'YYYY年M月D日ddddAh点mm分 A',
    l: 'YYYY/M/D',
    ll: 'YYYY年M月D日',
    lll: 'YYYY年M月D日 HH:mm A',
    llll: 'YYYY年M月D日dddd HH:mm A'
  }
});
dayjs.updateLocale('en', {
  weekStart: 1,
  calendar: {
    today: 'Today',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow'
  }
});

// 注意 目前假设用户不会在使用网站的过程中切换时区，所以只需要获取一次时区即可
const cache_localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const getLocalTimeZone = () => cache_localTimezone;

const cache_format = dayjs.prototype.format;

/** 日期格式化模板过滤
 * 注：为了统一适配dayjs和element-ui的日期时间组件以及date-fns的 格式化占位符，在这里做一个转化
*/
const templateReplaceSet = {
  yyyy: 'YYYY',
  yy: 'YY',
  ddd: 'ddd',
  dd: 'DD',
  d: 'D',
  EEE: 'ddd',
  EEEE: 'dddd',
  Today: 'Today',
  Yesterday: 'Yesterday',
  Tomorrow: 'Tomorrow'
};
const templateFormat = (date) => {
  /* res = /(yyyy|yy|ddd|dd|d|EEE|EEEE|(,-))/g */
  const reg = new RegExp(`(${Object.keys(templateReplaceSet).map(i => i).join('|')}|(,-))`, 'g');
  return date.replace(reg, item => templateReplaceSet[item]);
};

dayjs.extend((option, dayjsClass, dayjsFactory) => {
  let cache_local_org_timezone_offset = null;

  dayjsClass.prototype.format = function (template) {
    const toFormat = cache_format.bind(this);
    return toFormat(templateFormat(template));
  };

  dayjsClass.prototype.getLocalOrgTimeZoneOffset = function () {
    // 因为组织时区返回了 GTM+8:00，getTimezoneOffset 里面的参数需要是 Asia/Shanghai 或者 +8:00 这种
    // 注意 同样的，目前假设用户不会在使用网站的过程中切换时区和修改组织时区
    if (cache_local_org_timezone_offset === null) {
      cache_local_org_timezone_offset = -getTimezoneOffset(getLocalTimeZone(), this.toDate()) + getTimezoneOffset(dayjsFactory.orgTimeZone.replace('GMT', ''), this.toDate());
    }
    return cache_local_org_timezone_offset;
  };

  dayjsClass.prototype.moveToOrgTimeZone = function () {
    return dayjsFactory(this.getTime() - this.getLocalOrgTimeZoneOffset());
  };

  dayjsClass.prototype.moveToLocalTimeZone = function () {
    return dayjsFactory(this.getTime() + this.getLocalOrgTimeZoneOffset());
  };

  dayjsClass.prototype.getTime = function () {
    return this.valueOf();
  };

  dayjsFactory.forOrgTimeZone = function (...args) {
    return dayjsFactory(...args).tz(dayjsFactory.orgTimeZone);
  };

  dayjsFactory.orgTimeZone = 'Asia/Shanghai';
});
